import React from 'react';
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {PaginationProvider} from "react-bootstrap-table2-paginator";
import * as uiHelpers from "../../LicensesUIHelpers";
import {getHandlerTableChange, NoRecordsFoundMessage, PleaseWaitMessage} from "../../../../../_metronic/_helpers";
import {Pagination} from "../../../../../_metronic/_partials/controls";
import {useCompanyApiKeys} from "../hooks/useCompanyApiKeys";
import {useDispatch} from "react-redux";
import CompanyApiKeyFilter from "./CompanyApiKeyFilter";
import CompanyApiKeyActionModal, {COMPANY_API_KEY_ACTION} from "./CompanyApiKeyActionModal";
import * as companyApiKeysActions from "../store/companyApiKeysActions";

const initialQueryParams = {
  filter: {resellerId: "", companyId: "", status: "", searchText: ""},
  pageNumber: 1,
  pageSize: 10,
};

function CompanyApiKeyList() {
  const [queryParams, setQueryParams] = React.useState(initialQueryParams);
  // reseller chosen in the filter form (before Search) - used to load the companies of that reseller
  const [selectedResellerId, setSelectedResellerId] = React.useState("");
  const dispatch = useDispatch();
  const [actionState, setActionState] = React.useState({action: null, row: null, loading: false});

  const handleRevoke = React.useCallback(
    row => setActionState({action: COMPANY_API_KEY_ACTION.REVOKE, row, loading: false}), []);
  const handleReactivate = React.useCallback(
    row => setActionState({action: COMPANY_API_KEY_ACTION.REACTIVATE, row, loading: false}), []);
  const closeActionModal = () => setActionState({action: null, row: null, loading: false});

  const {reload, entities, totalCount, companyOptions, resellerOptions, loading, tableCols} =
    useCompanyApiKeys(queryParams, selectedResellerId, handleRevoke, handleReactivate);

  const confirmAction = () => {
    const {action, row} = actionState;
    setActionState(prev => ({...prev, loading: true}));
    const request = action === COMPANY_API_KEY_ACTION.REVOKE
      ? companyApiKeysActions.revokeCompanyApiKey(row.id)
      : companyApiKeysActions.reactivateCompanyApiKey(row.id);
    return dispatch(request).then(response => {
      closeActionModal();
      if (response) {
        reload();
      }
    });
  };

  const handleApply = (values) => {
    setQueryParams(prev => ({
      ...prev,
      filter: {...initialQueryParams.filter, ...values},
      pageNumber: 1,
    }));
  };
  const handleReset = () => {
    setSelectedResellerId("");
    setQueryParams(prev => ({...initialQueryParams, pageSize: prev.pageSize}));
  };

  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: queryParams.pageSize,
    page: queryParams.pageNumber,
  };
  return (
    <div>
      <CompanyApiKeyFilter
        totalCount={totalCount}
        loading={loading}
        companyOptions={companyOptions}
        resellerOptions={resellerOptions}
        onResellerChange={setSelectedResellerId}
        onApply={handleApply}
        onReset={handleReset}
      />
      <CompanyApiKeyActionModal
        action={actionState.action}
        row={actionState.row}
        loading={actionState.loading}
        onConfirm={confirmAction}
        onHide={closeActionModal}
      />
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({paginationProps, paginationTableProps}) => {
          return (
            <Pagination
              isLoading={loading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                bordered={false}
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                remote
                keyField="id"
                data={entities === null ? [] : entities}
                columns={tableCols}
                onTableChange={getHandlerTableChange(setQueryParams)}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities}/>
                <NoRecordsFoundMessage entities={entities}/>
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </div>
  );
}

CompanyApiKeyList.propTypes = {};
CompanyApiKeyList.defaultProps = {};

export default CompanyApiKeyList;
